const loadLazyLoadedVideos = () => {
	const lazyVideos = document.querySelectorAll( ".js-video-lazy-load" );

	lazyVideos.forEach( video => {
		if ( video.getAttribute( "src" ) ) {
			return;
		}

		let videoSrc = "";

		if ( video.getAttribute( "data-custom-video-lazy-src" ) ) {
			videoSrc = video.getAttribute( "data-custom-video-lazy-src" );
		} else {
			const childWithSrc = video.querySelector( "[data-custom-video-lazy-src]" );

			if ( !childWithSrc ) {
				return;
			}

			videoSrc = childWithSrc.getAttribute( "data-custom-video-lazy-src" );
		}

		video.addEventListener( "canplay", handleVideoCanPlay, {once: true} );
		video.addEventListener( "playing", handleVideoPlaying, {once: true} );

		video.setAttribute( "src", videoSrc );
		video.load();

		function handleVideoCanPlay() {
			if ( !video.hasAttribute( "autoplay" ) ) {
				video.classList.add( "is-loaded" );
				return;
			}

			video.play().catch( error => {
				if ( error.name === "AbortError" ) {
					return;
				}

				console.error( "The video could not autoplay:", error );
			} );
		}

		function handleVideoPlaying() {
			video.classList.add( "is-loaded" );
		}
	} );
};

export default loadLazyLoadedVideos;